import { useRef } from "react";

const clamp = (v) => Math.max(3, Math.min(97, v));

export function MediaOverlays({ edits, editable = false, selected, onSelect, onMove }) {
  const ref = useRef(null);
  const drag = useRef(null);
  const items = [
    ...(edits.texts || []).map((t, idx) => ({ ...t, kind: "texts", idx })),
    ...(edits.stickers || []).map((s, idx) => ({ ...s, kind: "stickers", idx })),
  ];

  const move = (e) => {
    if (!drag.current) return;
    const r = ref.current.getBoundingClientRect();
    onMove(drag.current, clamp(((e.clientX - r.left) / r.width) * 100), clamp(((e.clientY - r.top) / r.height) * 100));
  };

  return (
    <div ref={ref} className={`absolute inset-0 ${editable ? "" : "pointer-events-none"}`} style={{ containerType: "inline-size" }}
      onPointerMove={move} onPointerUp={() => (drag.current = null)} onPointerDown={() => editable && onSelect(null)} data-testid="media-overlays">
      {items.map((it) => {
        const isSel = selected && selected.kind === it.kind && selected.idx === it.idx;
        return (
          <div key={`${it.kind}-${it.idx}`} data-testid={`overlay-${it.kind}-${it.idx}`}
            onPointerDown={(e) => {
              if (!editable) return;
              e.stopPropagation();
              e.currentTarget.setPointerCapture(e.pointerId);
              drag.current = { kind: it.kind, idx: it.idx };
              onSelect({ kind: it.kind, idx: it.idx });
            }}
            className={`absolute -translate-x-1/2 -translate-y-1/2 select-none touch-none whitespace-nowrap leading-none ${editable ? "cursor-move" : ""} ${isSel ? "rounded-lg outline-dashed outline-2 outline-white/80 outline-offset-4" : ""}`}
            style={{ left: `${it.x}%`, top: `${it.y}%`, fontSize: `${it.size / 3.6}cqw`, color: it.color }}>
            {it.kind === "texts" ? <span className="font-extrabold" style={{ textShadow: "0 2px 10px rgba(0,0,0,.65)" }}>{it.text}</span> : it.emoji}
          </div>
        );
      })}
    </div>
  );
}
